if (!process.env.VUE_APP_IS_WEB) {
  var BuildingOwnerDB = require("../database/models/BuildingOwner");
}

import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";

export default {
  FETCH(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingOwnerDB()
          .query({ where: { deleted: null, building_id: buildingId } })
          .fetchAll()
          .then(res => {
            BuildingOwnerORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .FETCH(buildingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(buildingId, queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .QUERY_FETCH(buildingId, queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH_FOR_BUILDING_CATALOG(queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .QUERY_FETCH_FOR_BUILDING_CATALOG(queryParams)
          .then(res => {
            BuildingOwnerORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingOwnerDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            let data = res.serialize();
            BuildingOwnerORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER(item) {
    return new Promise((resolve, reject) => {
      BuildingOwnerORM.api()
        .REGISTER(
          JSON.stringify({
            email: item.email,
            generate: true,
            timezone: localStorage.getItem("timezone"),
          })
        )
        .then(res => {
          resolve(res.response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new BuildingOwnerDB(itemPost)
          .save()
          .then(res => {
            let data = res.serialize();
            BuildingOwnerORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new BuildingOwnerDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            let data = res.serialize();
            BuildingOwnerORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new BuildingOwnerDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            BuildingOwnerORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CUSTOM_DELETE(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      //  TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .CUSTOM_DELETE(id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async BULK_DELETE(buildingId, items = []) {
    console.log("bulk delete items", items);

    if (!process.env.VUE_APP_IS_WEB) {
      var buildingOwners = JSON.parse(JSON.stringify(items));

      // NOTE: for success / error handling
      var deletedItemsCount = 0;
      var errors = [];

      for (const buildingOwner of buildingOwners) {
        await new BuildingOwnerDB(buildingOwner)
          .save(null, { isDelete: true })
          .then(res => {
            deletedItemsCount++;
            BuildingOwnerORM.delete(buildingOwner.id);
          })
          .catch(err => {
            errors.push(err);
          });
      }

      return new Promise((resolve, reject) => {
        if (errors.length == 0) {
          resolve({
            status: "success",
            message: "The process completed successfully.",
            deleted_items_count: deletedItemsCount,
          });
        } else {
          reject({
            status: "error",
            message: "There were some errors in the process.",
            errors: errors,
            deleted_items_count: deletedItemsCount,
          });
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        var arrayOfIds = [];
        items.forEach(item => {
          arrayOfIds.push(item.id);
        });
        // ???: agencyId, token, refreshToken ??
        BuildingOwnerORM.api()
          .BULK_DELETE(
            arrayOfIds,
            buildingId,
            parseInt(localStorage.getItem("agencyId")),
            localStorage.getItem("token"),
            localStorage.getItem("refresh_token")
          )
          .then(res => {
            // TODO: action to delete from store
            arrayOfIds.forEach(id => {
              BuildingOwnerORM.delete(id);
            });
            resolve({
              status: "success",
              message: "The process completed successfully.",
              deleted_items_count: arrayOfIds.length,
              res: res,
            });
          })
          .catch(err => {
            // ..
            reject(err);
          });
      });
    }
  },
  GET_TOTAL_VOTING_RIGHT_PARTS(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .GET_TOTAL_VOTING_RIGHT_PARTS(buildingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  /**
   * FIXME: check if already exists..
   * FIXME: error handling
   * TODO: update entity if it exists
   * INFO:
   * 1. create new voting categories, building lots and building owners
   * 2. attach building lots to building owners (creating join table rows in: building_owner_building_lot)
   * 3. use newly created join table rows ids and newly created voting categories ids to create new building owner voting rights
   */
  async IMPORT(items, buildingId) {
    // TODO: check if is online
    return new Promise((resolve, reject) => {
      BuildingOwnerORM.api()
        .IMPORT(
          items,
          buildingId,
          parseInt(localStorage.getItem("agencyId")),
          localStorage.getItem("token"),
          localStorage.getItem("refresh_token")
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  ADD_EDIT_COOWNER_PROCESS(items) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .ADD_EDIT_COOWNER_PROCESS(items)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED(data) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: ??
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED(data)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  EXECUTE_DEPART_BUILDING_LOT(data) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: ??
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .EXECUTE_DEPART_BUILDING_LOT(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER_GET_BUILDING_OWNERS(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .REGISTER_GET_BUILDING_OWNERS(meetingId)
          .then(res => {
            BuildingOwnerORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  SET_LRE_AGREEMENT(items) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerORM.api()
          .SET_LRE_AGREEMENT(items)
          .then(res => {
            BuildingOwnerORM.insertOrUpdate({
              data: res.data,
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
